/**
 * Resolve the effective styles for a given breakpoint.
 * desktop is the base, tablet inherits desktop, and mobile inherits tablet.
 * Properties not defined at a narrower breakpoint fall back up the cascade.
 */
export function resolveStyles(styles, breakpoint) {
    if (breakpoint === 'desktop')
        return styles.desktop;
    if (breakpoint === 'tablet')
        return { ...styles.desktop, ...(styles.tablet ?? {}) };
    return { ...styles.desktop, ...(styles.tablet ?? {}), ...(styles.mobile ?? {}) };
}
/**
 * Convert a StyleProperties object to a plain Record<string, string>,
 * stripping out any undefined or empty-string values.
 */
export function stylesToRecord(styles) {
    const result = {};
    for (const [key, value] of Object.entries(styles)) {
        if (key === 'margin' || key.startsWith('margin'))
            continue;
        if (value !== undefined && value !== '') {
            result[key] = value;
        }
    }
    return result;
}
//# sourceMappingURL=resolve.js.map